import { render, staticRenderFns } from "./FrontOffices.vue?vue&type=template&id=d5978df0&"
import script from "./FrontOffices.vue?vue&type=script&lang=js&"
export * from "./FrontOffices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports